import * as React from "react"
import trans from "trans"

import {
    GridCell,
    FieldLabel,
    Icon,
} from "@bdfx/mergado-ui-kit"

import {StyledSliderDiv} from "./filters";
import { Slider } from "@mui/material";
import { selectFormValues, updateInputValue } from "app/reducers/form";
import { connect } from "react-redux";
import { FiltersFormType } from "products/types/filtertypes";
import { StyledInputGroupFilter } from "shape-edit/forms/fields";


interface Props {
    setIsDirty: Function
    filtersForm: FiltersFormType
    updateInputValue: typeof updateInputValue
}

class QualityFilters extends React.Component<Props> {
    constructor(props: Props) {
        super(props)
    }

    render() {
        const { filtersForm } = this.props

        const filterStatuses = filtersForm.quality?.status && Array.isArray(filtersForm.quality.status) ? filtersForm.quality.status : ['NOT_OK']    //multiselect!!!
        const filterWithBadQuality = filterStatuses.includes('NOT_OK')  //with or without, watermarks, default filter products with watermarks

        const isFromNull = typeof filtersForm.quality?.confidence?.from === "undefined" || filtersForm.quality.confidence.from === null
        const isToNull = typeof filtersForm.quality?.confidence?.to === "undefined" || filtersForm.quality.confidence?.to === null

        const filterFrom = filterWithBadQuality ? (isFromNull ? 50 : parseInt(`${filtersForm.quality.confidence.from}`)) : 0
        const filterTo = !filterWithBadQuality ? (isToNull ? 50 : parseInt(`${filtersForm.quality.confidence.to}`)) : 100

        return (
            <React.Fragment>
                <GridCell className={!isFromNull || !isToNull ? 'active-filter' : ''}>
                    <div style={{ display: 'flex' }}>
                        <FieldLabel><Icon type="diamond" text={trans('bad_quality_score')} /></FieldLabel>
                        {(!isFromNull || !isToNull) &&
                            <span className='clickable' onClick={() => this.props.updateInputValue('filtersForm', 'quality.confidence', null)}>
                                <Icon type={'close-light'} color={'#3a3a3a'} />
                            </span>
                        }
                    </div>

                    <StyledSliderDiv>
                        <Slider
                            value={filterWithBadQuality ? filterFrom : filterTo}
                            onChange={(event: Event, value: number[]) => {
                                if (filterWithBadQuality) {
                                    this.props.updateInputValue('filtersForm', 'quality', {
                                        ...filtersForm.quality,
                                        confidence: {
                                            from: value,
                                            to: 100,
                                        },
                                    })
                                } else {
                                    this.props.updateInputValue('filtersForm', 'quality', {
                                        ...filtersForm.quality,
                                        confidence: {
                                            from: 0,
                                            to: value,
                                        },
                                    })
                                }
                            }}
                            color={isFromNull && isToNull ? 'secondary' : 'primary'}
                            track={filterWithBadQuality ? "inverted" : "normal"}
                            step={1}
                            min={0}
                            max={100}
                            marks={[{ value: 0, label: '0%' }, { value: 25 }, { value: 50, label: '50%' }, { value: 75 }, { value: 100, label: '100%' }]}
                            /* marks={[{ value: 0, label: trans('good_quality') }, { value: 25 }, { value: 50, label: trans('middle_quality') }, { value: 75 }, { value: 100, label: trans('bad_quality') }]} */
                            valueLabelDisplay="auto"
                            getAriaLabel={() => `${trans('filter_probability')} [%]`}
                            getAriaValueText={(value) => `${value}%`}
                            valueLabelFormat={(value) => `${value}%`}
                        />
                    </StyledSliderDiv>
                </GridCell>

                <GridCell className={filtersForm.quality.user_set ? 'active-filter' : ''}>
                    <StyledInputGroupFilter
                        formName='filtersForm.quality.user_set'
                        singleChoice={true}
                        onChange={() => this.props.setIsDirty(true)}
                        transString={'filter_user_set'}
                        iconType={'diamond'}
                        showClear={filtersForm.quality.user_set}
                        items={[
                            { value: '0', label: trans('status_NOT_OK') },
                            { value: '1', label: trans('status_OK') },
                        ]}
                        onClear={() => {
                            this.props.updateInputValue('filtersForm', 'quality.user_set', null)
                            this.props.setIsDirty(true)
                        }}
                    />
                </GridCell>
            </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
        filtersForm: selectFormValues(state, 'filtersForm'),
    }
}

export default connect(mapStateToProps, {
    updateInputValue,
})(QualityFilters)
